<template>
    <div id="reply-input-area" :class="[visible ? 'visible' : 'hidden']" @touchmove.prevent @wheel.prevent>
        <div class="confirm-content">
            <div class="input-area" @click.stop>
                <textarea @touchmove.stop @wheel.stop rows="3" :placeholder="placeholder" v-model="content" ref="input" @focus="onFocus" @blur="onBlur"/>
                <i v-if="imageVisible" class="myicon myicon-image" @click="handleUpload"></i>
            </div>
            <div class="operate-area" @click.stop>
                <span class="cancel" @click="handleCancel">取消</span>
                <span class="count" v-show="content.length >= 450"><span :class="[content.length > 500 && 'max']">{{content.length}}</span>/500</span>
                <span :class="['confirm', disabled && 'disabled']" @click="handleConfirm">提交</span>
            </div>
        </div>
    </div>
</template>

<script>
import appLink from '@/common/js/appLink'
import { throttle } from '@/common/js/function'
export default {
    data () {
        return {
            content: '',
            visible: false,
            left: 0,
            top: 0,
            callback: null,
            imageVisible: false,
            placeholder: '快来说点什么…'
        }
    },
    computed: {
        disabled: function() {
            return !this.content.length || this.content.length > 500
        }
    },
    watch: {
        '$route' () {
            // this.close()
        }
    },
    methods: {
        focus (callback, placeholder = '快来说点什么…') {
            this.visible = true
            this.placeholder = placeholder
            this.imageVisible = this.GLOBAL.REPLY_INPUT_IMAGE_VISIBLE
            this.$refs.input.focus()

            this.callback = callback
        },
        onBlur() {
            // this.visible = false
        },
        onFocus() {
            // console.log(11)
        },
        close () {
            this.visible = false
            this.content = ''
        },
        handleAnimationEnd () {
            if (!this.visible) {
                this.title = ''
                this.message = ''
                this.btn = ''
                this.confirmClass = ''
                this.cancleText = ''
                this.confirmText = ''
            }
            // this.$refs.input.focus()
        },
        handleUpload() {
            this.$confirm({
                title: '网页端暂不支持图片上传，下载并打开果壳App体验完整功能。',
                confirmText: '打开App',
                cancleText: '留在网页'
            }).then(() => {
                this.openApp()
            }).catch(() => {
            })
        },
        handleCancel () {
            this.close()
        },
        openApp (toMain = false, {query: _query = {}} = {}) {
            const path = new URL(window.location.href).pathname
            appLink.open({
                path: toMain ? '/' : path,
                query: {
                    ..._query
                }
            })
        },
        handleConfirm: throttle(async function() {
            if (this.disabled) return
            try {
                if (this.callback) {
                    await this.callback(this.content)
                    this.$toast('评论成功')
                    this.close()
                }
            } catch(err) {
                this.$toast(err?.body?.message || '评论失败')
            }
        }, 1000),
    },
    mounted() {
    }
}
</script>

<style lang="less" scoped>
@keyframes Show {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes Hide {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
#reply-input-area {
    position: fixed;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
    &.visible {
        z-index: 99;
        opacity: 1;
    }
    &.hidden {
        z-index: -1;
        opacity: 0;
    }
    .confirm-content {
        background-color: #fff;
        padding-top: 1.6rem;
        .input-area {
            background-color: #F7F7F7;
            border-radius: 4px;
            margin: 0 1.6rem;
            padding: 1.6rem;
            textarea {
                background-color: transparent;
                border: none;
                outline: none;
                font-size: @font-size-base;
                color: #1A1A1A;
                line-height: 1.5;
                width: 100%;
                word-break: break-all;
            }
            .myicon-image {
                font-size: 2rem;
                color: @font-color-third;
            }
        }
        .operate-area {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .cancel, .confirm {
                padding: 1.6rem;
                font-size: @font-size-base;
            }
            .cancel {
                color: #666666;
            }
            .confirm {
                color: #3355FF;
                &.disabled {
                    color: @font-color-third;
                }
            }
            .count {
                font-size: @font-size-sm;
                color: rgba(0, 0, 0, 0.3);
                .max {
                    color: #FF785A;
                }
            }
        }
    }
}
</style>